import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'itl-maintenance-info-modal',
  templateUrl: './maintenance-info-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MaintenanceInfoModalComponent implements AfterViewInit {
  public componentProps: any;
  public title: string;
  public subTitle: string;
  private _userFirstName: string;
  constructor(
    private _accountService: AccountService,
    private _changeDetectionRef: ChangeDetectorRef,
    private _translate: TranslateService
  ) {}

  async ngAfterViewInit(): Promise<void> {
    this._userFirstName = (await this._accountService.getAccount())?.firstName;
    this.title = `${this._translate.instant('greeting')} ${this._userFirstName},`;
    const start = new Date(this.componentProps.startDate);
    if (moment().isAfter(moment(start))) {
      this.subTitle = this._translate.instant('maintenance.infoModal.maintenanceActive');
    } else {
      this.subTitle = `${this._translate.instant('maintenance.infoModal.maintenanceStarting_1')} ${moment(start).format(
        `DD.MM [${this._translate.instant('at')}] H [${this._translate.instant('timeSuffix')}]`
      )} ${this._translate.instant('maintenance.infoModal.maintenanceStarting_2')}`;
    }
    this._changeDetectionRef.detectChanges();
  }
}
